import { Box } from "@mui/material";
import { keyframes } from "@emotion/react";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const LoadingPage = () => {
    return (
        <Box
            sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "#f1eeecf5",
                backdropFilter: "blur(10px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 9999,
            }}
        >
            <Box
                sx={{
                    width: 65,
                    height: 65,
                    animation: `${spin} 1.7s linear infinite`,
                }}
                dangerouslySetInnerHTML={{
                    __html: `
            <svg xmlns="http://www.w3.org/2000/svg" width="65.2" height="65.2" viewBox="0 0 65.2 65.2">
              <path d="m0,65.2h65.2V0H0v65.2h0ZM5.5,5.5h54.2v54.2H5.5V5.5Z" style="fill: #515049;"/>
            </svg>
          `,
                }}
            />
        </Box>
    );
};

export default LoadingPage;
